module.exports = __webpack_public_path__ + "img/SketchPng0d16e3f62cccb30c67f14f915f91b948eb53ca5769a542474ee1d6a9a10863ea.bb04046a.png";